var exports = {
  "JU": "Label__125oG4",
  "Ay": "default__P7CQg1",
  "OR": "danger__bMi9bO",
};

module.exports = exports;
